import KpValueEditor from '../commons/value-editors/kp-value-editor/KpValueEditor.svelte';
import type {UrlStateManagerService} from '../commons/services/url-state-manager.service';
import type {LocalizationService} from '../commons/providers/localization.provider';
import type {IHttpService, ILogService, IScope} from 'angular';
import type {EditedProperty} from 'typings/portaro.be.types';
import type {Subscription} from 'rxjs';
import type {ModelInputChangeEvent} from '../commons/value-editors/events';
import {getErrorMessage, responseToData, transferify} from 'shared/utils/data-service-utils';
import { ngAsync } from 'shared/utils/ng-@decorators';
import {prepareFormFields, updateEditorsIsDisabledProperty, updateEditorsModelProperty} from './utils';

declare global {
    interface Window {
        model: any & {
            view: {
                text: null,
                fields: EditedProperty[],
                submitPath: string,
                pageClass: string,
                params: Record<string, any>
            };
        }
    }
}

export class OverallStatsController {
    public static controllerName = 'OverallStatsCtrl';

    public kpValueEditorComponent = KpValueEditor;
    public params: Record<string, any>;
    public data: Record<string, any>;
    public formFields: EditedProperty[];

    private submitPath: string;
    private originalFieldsSettings: EditedProperty[];
    private isLoading = false;
    private subscription: Subscription;

    /*@ngInject*/
    constructor(private urlStateManagerService: UrlStateManagerService,
                private localizationService: LocalizationService,
                private $http: IHttpService,
                private $scope: IScope,
                private $log: ILogService) {}


    public init() {
        this.originalFieldsSettings = window.model.view.fields;
        this.submitPath = window.model.view.submitPath;
        this.params = window.model.view.params ?? {};


        this.urlStateManagerService.register((params) => this.onStateChange(params));

        this.formFields = prepareFormFields(this.originalFieldsSettings);

        this.subscription = this.urlStateManagerService.isLoading$().subscribe((isLoading) => {
            this.isLoading = isLoading;
            this.formFields = updateEditorsIsDisabledProperty(this.formFields, isLoading);
        });

        this.$scope.$on('$destroy', () => {
            this.subscription.unsubscribe();
        });
    }

    public onChange(event: ModelInputChangeEvent<any>, fieldName: string) {
        this.params[fieldName] = event.detail;
        this.formFields = updateEditorsModelProperty(this.formFields, this.params);
    }

    @ngAsync()
    public onSubmit(): Promise<void> {
        return this.urlStateManagerService.requestChangeState(transferify(this.params));
    }

    @ngAsync()
    private onStateChange(params): Promise<void> {
        params = transferify(params);
        return Promise.resolve(this.$http.get(this.submitPath, {params}))
            .then(responseToData)
            .then((data: any) => {
                this.data = data.result ;
                this.params = data.params;
                this.formFields = updateEditorsModelProperty(this.formFields, this.params);
            })
            .catch((error) => this.$log.error(getErrorMessage(error)));

    }
}